export default __webpack_public_path__ + "static/media/logoLight.1609722e.svg";